<template>
  <div class="tab-text md:ml-4 md:mt-0 mt-4 ml-0">
    <vx-card no-shadow class="custom-min-height">
      <ValidationObserver v-slot="{ handleSubmit }" ref="form">
        <form @submit.prevent="handleSubmit">

          <div class="vx-row flex flex-wrap mb-4">
            <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/2">
              <validation-provider name="ชื่อบริษัท" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">ชื่อบริษัท*</label>
                <vs-input type="text" class="w-full" v-model="form.companyName"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/2">
              <validation-provider name="ชื่อบริษัท (Eng)" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">ชื่อบริษัท (Eng)*</label>
                <vs-input type="text" class="w-full" v-model="form.companyNameEn"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
          <div class="vx-row flex flex-wrap mb-4">
            <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/2">
              <validation-provider name="เบอร์โทรศัพท์" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">เบอร์โทรศัพท์*</label>
                <vs-input type="text" class="w-full" v-model="form.companyPhone"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/2">
              <validation-provider name="อีเมล์" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">อีเมล์*</label>
                <vs-input type="text" class="w-full" v-model="form.companyEmail"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
          <div class="vx-row flex flex-wrap mb-4">
            <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/2">
              <validation-provider name="Line Contact" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">Line Contact*</label>
                <vs-input type="text" class="w-full" v-model="form.companyLine"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/2">
              <validation-provider name="Line Contact ID" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">Line Contact ID*</label>
                <vs-input type="text" class="w-full" v-model="form.companyLineId"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>

          <div class="vx-row">
            <div class="vx-col w-full flex flex-col sm:flex-row sm:justify-end mt-base">
              <vs-button class="ml-auto mt-2" @click="summit()">บันทึก</vs-button>
              <vs-button class="ml-4 mt-2" type="border" color="warning">คืนค่า</vs-button>
            </div>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </div>
</template>

<script>
import {ValidationProvider} from "vee-validate";
import {createNamespacedHelpers} from "vuex";
const { mapActions: mapSystemActions, mapState: mapSystemState } = createNamespacedHelpers('System')

export default {
  components: {
    ValidationProvider,
  },
  data() {
    return {
      form: {
        id: '',
        companyName: '',
        companyNameEn: '',
        companyPhone: '',
        companyLine: '',
        companyLineId: '',
        companyEmail: '',
      },
    };
  },
  computed: {
    ...mapSystemState(['status', 'config']),
  },
  methods : {
    ...mapSystemActions([
      'initializing',
      'getConfig',
      'updateConfig',
    ]),
    async summit () {
      const vm = this
      vm.$refs['form'].validate().then(async success => {
        if (!success) {
          return
        }
        const {updateConfig} = vm
        updateConfig({
          form: {
            companyName: vm.form.companyName,
            companyNameEn: vm.form.companyNameEn,
            companyPhone: vm.form.companyPhone,
            companyLine: vm.form.companyLine,
            companyLineId: vm.form.companyLineId,
            companyEmail: vm.form.companyEmail,
          },
          vm
        })
      })
    },
    async initDate() {
      const vm = this;
      const {getConfig } = vm
      // set form data
      await getConfig();
      vm.form = {
        companyName: vm.config.companyName,
        companyNameEn: vm.config.companyNameEn,
        companyPhone: vm.config.companyPhone,
        companyLine: vm.config.companyLine,
        companyLineId: vm.config.companyLineId,
        companyEmail: vm.config.companyEmail,
      }
    }
  },
  async created () {
    await this.initDate()
  },
};
</script>


<style scoped>
.custom-min-height {
  min-height: 500px; /* Set your desired minimum height */
}
.position-bottom-right {
  align-self: flex-end;
  margin: 16px; /* Adjust the margin as needed */
}
</style>
